<template>
  <div>
    <header>
      <div>
        <div class="brand">
          <router-link to="/">
            <img src="@/assets/image/main-logo.png" alt="Logo robomarket" />
          </router-link>
        </div>
      </div>

      <div class="links hidden-sm-and-down">
        <v-btn text class="black-color" dark to="/">Home</v-btn>
        <v-btn text class="black-color" dark to="/como-funciona">Como funciona</v-btn>
        <v-btn text class="black-color" dark to="/about">Quem somos</v-btn>
        <v-btn text class="black-color" dark to="/contato">Contato</v-btn>
        <v-btn text class="black-color" dark to="/signin">Entrar</v-btn>
        <v-btn tile to="/criar-conta/user" dark>Cadastre-se</v-btn>
      </div>

      <v-btn color="black" class="hidden-md-and-up" icon dark @click.stop="drawer = !drawer">
        <v-icon>fas fa-bars</v-icon>
      </v-btn>
    </header>

    <v-navigation-drawer v-model="drawer" absolute temporary right>
      <v-list-item>
        <!-- <v-list-item-avatar>
          
        </v-list-item-avatar> -->

        <v-list-item-content>
          <v-img src="@/assets/image/main-logo.png"></v-img>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="item in menu" :key="item.title" link :to="item.to" :href="item.href">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
             
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: null,
      menu: [
        { title: "Home", to: "/", icon: "fas fa-home" },
        { title: "Como funciona", to: "/como-funciona", icon: "fas fa-info-circle" },
        { title: "Quem somos", to: "/about", icon: "fas fa-question-circle" },
        { title: "Contato", to: "/contato", icon: "fas fa-envelope" },
        { title: "Entrar", href: "/signin", icon: "fas fa-user" },
        { title: "Criar conta", to: "/criar-conta", icon: "fas fa-user-plus" },
      ],
    };
  },
};
</script>

<style lang="scss">
header {
  padding: 10px 40px;
  background: #00ccff;
  display: flex !important;
  justify-content: space-between;

  .brand {
    img {
      width: 50%;
    }
  }

  .links {
    display: flex;
    align-items: center;

    .black-color {
      color: #000;
    }

    .v-btn {
      margin: 5px;
    }
  }
}
</style>